import { Trans } from '@lingui/react';
import { Card } from '@startuptools/ui/Card';
import { Table } from '@startuptools/ui/Table';
import { McApprovalStatus } from '../../../components/mc-approval-status/McApprovalStatus';
import { type GqlMeetingConcernsShowQuery } from './MeetingConcernsShow.graphql';
import { GqlWarrantProgramKind } from '../../../graphql/base-types.graphql';

const getUrl = (wpId: string, kind: GqlWarrantProgramKind) => {
  switch (kind) {
    case GqlWarrantProgramKind.Warrant: {
      return `/stock-options/warrant-programs/${wpId}`;
    }
    case GqlWarrantProgramKind.Employee: {
      return `/stock-options/employee-options/${wpId}`;
    }
    case GqlWarrantProgramKind.Wise: {
      return `/investments/wise-options/${wpId}`;
    }
    case GqlWarrantProgramKind.Nice: {
      return `/investments/nice-convertibles/${wpId}`;
    }
  }
};

export const MeetingConcernsTableWp = ({
  mcs,
  navigate,
}: {
  mcs: GqlMeetingConcernsShowQuery['meetingConcerns'];
  navigate: (to: string) => void;
}) => {
  return (
    <Card>
      <Table hoverRow>
        <thead>
          <tr>
            <th style={{ width: 160 }}>
              <Trans id="Appendix Number" />
            </th>
            <th style={{ width: 160 }}>
              <Trans id="Decision Status" />
            </th>
            <th style={{ width: 160 }}>
              <Trans id="Name" />
            </th>
            <th>
              <Trans id="Description" />
            </th>
          </tr>
        </thead>
        <tbody>
          {mcs.map(mc => (
            <tr
              key={mc.id}
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(getUrl(mc.warrantProgramId!, mc.warrantProgram!.warrantKind))}
            >
              <td>{mc.appendixNumber}</td>
              <td>
                <McApprovalStatus>{mc.approved}</McApprovalStatus>
              </td>
              <td>{mc.warrantProgram!.name}</td>
              <td>{mc.warrantProgram!.description}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  );
};
